import { useCallback, useEffect, useRef } from 'react';

import { RECAPTCHA_BASE_HEIGHT, RECAPTCHA_BASE_WIDTH } from '../constants';

type UseRecaptchaScaleToFitOptions = {
  enabled: boolean;
};

export const useRecaptchaScaleToFit = ({ enabled }: UseRecaptchaScaleToFitOptions) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const scaleRef = useRef<HTMLDivElement>(null);

  const updateScale = useCallback(() => {
    const wrapper = wrapperRef.current;
    const scaleLayer = scaleRef.current;

    if (!wrapper || !scaleLayer) {
      return;
    }

    const width = wrapper.clientWidth;
    if (!width) {
      return;
    }

    const scale = width / RECAPTCHA_BASE_WIDTH;
    scaleLayer.style.transform = `scale(${scale})`;
    scaleLayer.style.transformOrigin = '0 0';
    wrapper.style.height = `${RECAPTCHA_BASE_HEIGHT * scale}px`;
  }, []);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const wrapper = wrapperRef.current;
    if (!wrapper) {
      return undefined;
    }

    updateScale();

    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      updateScale();
    });

    observer.observe(wrapper);

    return () => {
      observer.disconnect();
    };
  }, [enabled, updateScale]);

  return {
    wrapperRef,
    scaleRef,
    updateScale,
    baseWidth: RECAPTCHA_BASE_WIDTH,
    baseHeight: RECAPTCHA_BASE_HEIGHT,
  };
};
